import React, { useState, useEffect } from 'react';
import {
  Paper,
  Typography,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  IconButton,
  Autocomplete,
  Chip,
  Stack,
  Snackbar,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import styled from '@emotion/styled';
import moment from 'moment';
import axios from '../../axiosConfig';

const OtherProcess = () => {
  const token =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  const { id } = useParams(); // For edit mode
  const navigate = useNavigate();

  const [selectedProcess, setSelectedProcess] = useState('');
  const [processDate, setProcessDate] = useState('');
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [processData, setProcessData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [styleData, setStyleData] = useState([]);
  const [operationDetails, setOperationDetails] = useState([
    {
      style: '',
      quantity: '',
      Obref: '',
      tsheaderId: '',
      styleDescription: '',
      styleNumber: '',
      tsNo: '',
    },
  ]);
  const [openLoader, setOpenLoader] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [existingData, setExistingData] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [obProduction, setObProduction] = useState(true);

  // Configuration for style API
  const [apiConfig] = useState({
    companyId: sessionStorage.getItem('CompanyId'),
    unitId: sessionStorage.getItem('factoryID'),
    fiscalYear: sessionStorage.getItem('FiscalYear'),
  });

  useEffect(() => {
    initializeData();
    GetOneControl();
  }, [id]);

  const GetOneControl = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(
        `/GetOneControlCenter/${sessionStorage.getItem('factoryID')}/${sessionStorage.getItem('CompanyId')}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        }
      );
      if (res.data.length > 0) {
        res.data.forEach((data) => {
          setObProduction(data.OBProduction === 'Y');
        });
      } else {
        setObProduction(false);
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Initialize all data
  const initializeData = async () => {
    setOpenLoader(true);
    try {
      // Load all necessary data first
      // await Promise.all([getAllProcessData(), getStyleDetails()]);
       await Promise.all([getAllProcessData()]);

      setDataLoaded(true);

      // Check if we're in edit mode after data is loaded
      if (id) {
        setIsEditMode(true);
        await getExistingOtherProcess(id);
      } else {
        // Set default date for new mode
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setProcessDate(formattedDate);
      }
    } catch (error) {
      console.error('Error initializing data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  // Validate if process already exists for the selected date
  const validateProcessSelection = async (processId, processDate) => {
    try {
      const validationData = {
        ProcessId: Number(processId),
        ProcessDate: processDate,
        CompanyId: Number(sessionStorage.getItem('CompanyId')),
        UnitId: Number(sessionStorage.getItem('factoryID')),
      };

      // Skip validation if we're in edit mode and the process/date hasn't changed
      if (isEditMode && existingData) {
        if (existingData.ProcessId.toString() === processId && existingData.ProcessDate === processDate) {
          return false; // No duplicate found (it's the same record)
        }
      }

      const res = await axios.instance.post('/GetAlreadyOtherProcess', validationData, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });

      // If response contains 'Y', it means process already exists
      return res.data[0]?.IsExist === 'Y';
    } catch (error) {
      console.error('Error validating process:', error);
      return false; // Don't block on validation error
    }
  };

  // Get existing OtherProcess data for edit mode
  const getExistingOtherProcess = async (otherProcessId) => {
    try {
     
      const res = await axios.instance.get(`/GetOtherProcessById/${otherProcessId}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });

      if (res.data && res.data.OtherProcessId) {
        // Ensure department employees are loaded before setting selected employees
        await getDeptEmployees(res.data.DepartmentId);
        setExistingData(res.data);

        // Set form values
        setSelectedProcess(res.data.ProcessId.toString());
        // setProcessDate(moment(res.data.ProcessDate).format('DD-MM-YYYY'));
        setProcessDate(moment(res.data.ProcessDate).format('YYYY-MM-DD'));

        // Set employees
        const employeeIds = res.data.Employee.map((emp) => emp.UserAccessID.toString());
        setSelectedEmployees(employeeIds);
        const data = await getAllProcessData();
        console.log(data, 'data');
        // Determine which styles to load based on the process name
        const processObj = data.find((p) => Number(p.ProcessId) === Number(res.data.ProcessId));
        console.log(processObj, 'processObj');
        
        const fromOB = processObj && (processObj.ProcessName === 'Cutting' || processObj.ProcessName === 'Production') ? 'Y' : 'N';

        // Fetch styles for this process and use the returned array directly (don't rely on stale state)
        const styles = await getStyleDetails(fromOB);

        // Set operation details with proper style formatting using the fetched styles
        const details = res.data.Details.map((detail) => {
          // Find the style in the freshly fetched styles to get TsNo for display
          const styleFromData = styles.find((style) => style.Tsheaderid === detail.TsheaderId);

          const displayStyle = styleFromData
            ? `${styleFromData.StyleDescription} - ${styleFromData.StyleNumber}`
            : `${detail.StyleDescription} - ${detail.StyleNumber}`;

          return {
            style: displayStyle,
            quantity: detail.Quantity,
            Obref: detail.Obref,
            tsheaderId: detail.TsheaderId,
            styleDescription: detail.StyleDescription,
            styleNumber: detail.StyleNumber,
            tsNo: styleFromData?.TsNo || '',
          };
        });

        setOperationDetails(
          details.length > 0
            ? details
            : [
                {
                  style: '',
                  quantity: '',
                  Obref: '',
                  tsheaderId: '',
                  styleDescription: '',
                  styleNumber: '',
                  tsNo: '',
                },
              ]
        );
      }
    } catch (error) {
      console.error('Error fetching existing process data:', error);
    }
  };

  // Get all process data from API
  const getAllProcessData = async () => {
    try {
      const userId = sessionStorage.getItem('UserID');
      const res = await axios.instance.get(`/GetLogProcessData/${userId}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setProcessData(res.data);
      return res.data;
    } catch (error) {
      console.error('Error fetching process data:', error);
      return [];
    }
  };

  // Get style details from API
  const getStyleDetails = async (fromOB) => {
    console.log('fromOB', fromOB);
    try {
      const res = await axios.instance.get(
        `/GetStyleDetails/${apiConfig.companyId}/${apiConfig.unitId}/${apiConfig.fiscalYear}/${fromOB}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        }
      );
      setStyleData(res.data);
      return res.data;
    } catch (error) {
      console.error('Error fetching style data:', error);
      return [];
    }
  };

  // Get employees based on selected process
  const getDeptEmployees = async (departmentId) => {
    try {
      const res = await axios.instance.get(`/GetDeptEmployee/${departmentId}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setEmployeeData(res.data);
      if (!res.data.length > 0) {
        setSelectedEmployees([]);
      }
    } catch (error) {
      console.error('Error fetching employee data:', error);
    }
  };

  // Handle process selection change
  const handleProcessChange = async (event) => {
    const selectedProcessId = event.target.value;
    const selectedProcessObj = processData.find((process) => process.ProcessId.toString() === selectedProcessId);
    console.log('selectedProcessId', selectedProcessObj);

    // In edit mode, don't allow changing process
    if (isEditMode) {
      setAlertType('warning');
      setAlertMessage('Process cannot be changed in edit mode.');
      setOpenAlert(true);
      return;
    }

    // Clear selected employees and set the selected process
    setSelectedEmployees([]);
    setSelectedProcess(selectedProcessId);

    // Immediately clear any selected style values in the details table
    setOperationDetails((prev) =>
      prev.map((item) => ({
        ...item,
        style: '',
        Obref: '',
        tsheaderId: '',
        styleDescription: '',
        styleNumber: '',
        tsNo: '',
        quantity: '',
      }))
    );

    // Clear available styles until new ones are loaded
    setStyleData([]);

    // Load department employees if available
    if (selectedProcessObj && selectedProcessObj.DepartmentId) {
      await getDeptEmployees(selectedProcessObj.DepartmentId);
    }

    // Load styles based on process type (await so options update after fetch)
    if (selectedProcessObj) {
      const fromOB =
        selectedProcessObj.ProcessName === 'Cutting' || selectedProcessObj.ProcessName === 'Production' ? 'Y' : 'N';
      await getStyleDetails(fromOB);
    }

    // Validate process selection if date is already selected
    if (processDate && selectedProcessId) {
      const isDuplicate = await validateProcessSelection(selectedProcessId, processDate);
      if (isDuplicate) {
        setAlertType('warning');
        setAlertMessage(
          'This process already exists for the selected date! Please select a different process or date.'
        );
        setOpenAlert(true);
      }
    }
  };

  // Handle date change with validation
  const handleDateChange = async (date) => {
    // Get today's date in YYYY-MM-DD format (same format as date input)
    const today = new Date().toISOString().split('T')[0];

    // Check if selected date is in the future
    if (date > today) {
      setAlertType('error');
      setAlertMessage('Future dates are not allowed! Please select today or a past date.');
      setOpenAlert(true);
      return; // Exit the function without updating the date
    }

    // In edit mode, don't allow changing date
    // if (isEditMode) {
    //     setAlertType('warning');
    //     setAlertMessage('Date cannot be changed in edit mode.');
    //     setOpenAlert(true);
    //     return;
    // }

    setProcessDate(date);

    // Validate process selection if process is already selected
    if (selectedProcess && date) {
      const isDuplicate = await validateProcessSelection(selectedProcess, date);
      if (isDuplicate) {
        setAlertType('warning');
        setAlertMessage(
          'This process already exists for the selected date! Please select a different process or date.'
        );
        setOpenAlert(true);
      }
    }
  };

  // Handle select all employees
  const handleSelectAllEmployees = (event) => {
    if (event.target.checked) {
      const allEmployeeIds = employeeData.map((emp) => emp.UserAccessID.toString());
      setSelectedEmployees(allEmployeeIds);
    } else {
      setSelectedEmployees([]);
    }
  };

  // Handle individual employee selection
  const handleEmployeeChange = (event) => {
    const {
      target: { value },
    } = event;
    // setSelectedEmployees(typeof value === 'string' ? value.split(',') : value);
    const filteredValue = value.filter((val) => val !== 'select-all');
    setSelectedEmployees(typeof filteredValue === 'string' ? filteredValue.split(',') : filteredValue);
  };

  // Check if all employees are selected
  const isAllEmployeesSelected = () => {
    return employeeData.length > 0 && selectedEmployees.length === employeeData.length;
  };

  // Check if some employees are selected (for indeterminate state)
  const isSomeEmployeesSelected = () => {
    return selectedEmployees.length > 0 && selectedEmployees.length < employeeData.length;
  };

  //   const handleStyleChange = (index, newValue) => {
  //     const updatedDetails = [...operationDetails];
  //     console.log('newValue', newValue);

  //     if (newValue) {
  //       // Find the complete style object
  //       //   const selectedStyle = styleData.find(
  //       //     (style) => `${style.TsNo} - ${style.StyleDescription} - ${style.StyleNumber}` === newValue
  //       //   );
  //       const selectedStyle = styleData.find((style) => style.Obref?.toString() === newValue?.Obref?.toString());

  //       if (selectedStyle) {
  //         updatedDetails[index] = {
  //           ...updatedDetails[index],
  //           style: newValue,
  //           Obref: selectedStyle.Obref,
  //           tsheaderId: selectedStyle.Tsheaderid,
  //           styleDescription: selectedStyle.StyleDescription,
  //           styleNumber: selectedStyle.StyleNumber,
  //           tsNo: selectedStyle.TsNo,
  //         };
  //       }
  //     } else {
  //       // Clear all style-related fields
  //       updatedDetails[index] = {
  //         ...updatedDetails[index],
  //         style: '',
  //         Obref: '',
  //         tsheaderId: '',
  //         styleDescription: '',
  //         styleNumber: '',
  //         tsNo: '',
  //       };
  //     }

  //     setOperationDetails(updatedDetails);
  //   };

  const handleStyleChange = (index, selectedOption) => {
    const updatedDetails = [...operationDetails];
    // console.log('selectedOption', selectedOption);

    if (selectedOption) {
      const selectedStyle = styleData.find(
      //   (style) => `${style.ObNo} - ${style.TsNo} - ${style.StyleDescription} - ${style.StyleNumber}` === selectedOption
      // );
       (style) => `${style.StyleDescription} - ${style.StyleNumber}` === selectedOption
      );
      //   const selectedStyle = styleData.find((style) => style.Obref.toString() === selectedOption.Obref.toString());
      console.log(selectedStyle, 'selectedStyle');
      updatedDetails[index] = {
        ...updatedDetails[index],
        // style: `${selectedStyle.ObNo} - ${selectedStyle.TsNo} - ${selectedStyle.StyleDescription} - ${selectedStyle.StyleNumber}`,
        style: `${selectedStyle.StyleDescription} - ${selectedStyle.StyleNumber}`,
        Obref: selectedStyle.Obref,
        tsheaderId: selectedStyle.Tsheaderid || 0,
        styleDescription: selectedStyle.StyleDescription,
        styleNumber: selectedStyle.StyleNumber,
        tsNo: selectedStyle.TsNo || 0,
      };
    } else {
      updatedDetails[index] = {
        ...updatedDetails[index],
        style: '',
        Obref: '',
        tsheaderId: 0,
        styleDescription: '',
        styleNumber: '',
        tsNo: 0,
      };
    }

    setOperationDetails(updatedDetails);
  };

  const handleQuantityChange = (index, value) => {
    const updatedDetails = [...operationDetails];
    updatedDetails[index] = {
      ...updatedDetails[index],
      quantity: value === '' ? '' : Number(value),
    };
    setOperationDetails(updatedDetails);
  };

  const handleAddRow = () => {
    setOperationDetails([
      ...operationDetails,
      {
        style: '',
        quantity: '',
        Obref: '',
        tsheaderId: '',
        styleDescription: '',
        styleNumber: '',
        tsNo: '',
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    if (operationDetails.length > 1) {
      const updatedDetails = operationDetails.filter((_, i) => i !== index);
      setOperationDetails(updatedDetails);
    }
  };

  const calculateTotal = () => {
    const values = operationDetails.map((detail) => detail.quantity).filter((val) => val !== '');
    return values.reduce((sum, current) => sum + current, 0);
  };

  // Get available styles for a specific row (exclude already selected styles from other rows)
  const getAvailableStylesForRow = (currentIndex) => {
    const selectedStyles = operationDetails
      .map((detail, index) => (index !== currentIndex ? detail.style : ''))
      .filter((style) => style !== '');

    // Format style data for display with TsNo
    const formattedStyles = styleData.map(
      // (style) => `${style.ObNo} - ${style.TsNo} - ${style.StyleDescription} - ${style.StyleNumber}`
      (style) => `${style.StyleDescription} - ${style.StyleNumber}`
    );

    return formattedStyles.filter((style) => !selectedStyles.includes(style));
  };

  // Prepare data for API submission
  const prepareSubmitData = () => {
    // Calculate total salary from selected employees
    const totalSalary = selectedEmployees.reduce((total, empId) => {
      const employee = employeeData.find((emp) => emp.UserAccessID.toString() === empId.toString());
      return total + parseFloat(employee?.Salary || 0);
    }, 0);

    // Calculate total quantity from operation details
    const totalQuantity = operationDetails
      //   .filter((detail) => detail.tsheaderId && detail.quantity)
      .filter((detail) => detail.Obref && detail.quantity)
      .reduce((total, detail) => total + Number(detail.quantity), 0);

    // Calculate per piece cost
    const perDaySalary = totalSalary / 26;
    const perPieceCost = totalQuantity > 0 ? perDaySalary / totalQuantity : 0;

    const submitData = {
      OpType: isEditMode ? 'Edit' : 'New',
      ProcessId: Number(selectedProcess),
      // ProcessDate: isEditMode ? moment(processDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : processDate,
      ProcessDate: processDate,
      CompanyId: Number(sessionStorage.getItem('CompanyId')),
      UnitId: Number(sessionStorage.getItem('factoryID')),
      TotalSalary: Number(totalSalary.toFixed(2)),
      TotalQty: Number(totalQuantity),
      PerPieceCost: Number(perPieceCost.toFixed(2)),
      CreatedBy: Number(sessionStorage.getItem('UserID')),
      ModifiedBy: Number(sessionStorage.getItem('UserID')),
      Employee: selectedEmployees.map((empId) => {
        const employee = employeeData.find((emp) => emp.UserAccessID.toString() === empId.toString());
        return {
          employeeId: Number(empId),
          salary: employee?.Salary || 0,
        };
      }),
      Details: operationDetails
        .filter((detail) => detail.Obref && detail.quantity)
        .map((detail) => ({
          Obref: Number(detail.Obref),
          TsheaderId: detail.tsheaderId ? Number(detail.tsheaderId) : 0,
          //   TsheaderId: Number(detail.tsheaderId),
          StyleDescription: detail.styleDescription,
          StyleNumber: detail.styleNumber,
          Quantity: Number(detail.quantity),
        })),
    };

    // Add OtherProcessId for edit mode
    if (isEditMode && existingData) {
      submitData.OtherProcessId = Number(existingData.OtherProcessId);
    }

    return submitData;
  };

  // Handle form submission
  const handleSubmit = async () => {
    // Validation
    if (!selectedProcess) {
      setAlertType('error');
      setAlertMessage('Please select a process');
      setOpenAlert(true);
      return;
    }

    if (!processDate) {
      setAlertType('error');
      setAlertMessage('Please select a date');
      setOpenAlert(true);
      return;
    }

    if (selectedEmployees.length === 0) {
      setAlertType('error');
      setAlertMessage('Please select at least one employee');
      setOpenAlert(true);
      return;
    }

    const validDetails = operationDetails.filter((detail) => detail.Obref && detail.quantity);
    if (validDetails.length === 0) {
      setAlertType('error');
      setAlertMessage('Please add at least one style with quantity');
      setOpenAlert(true);
      return;
    }

    // Final validation before submission (only for new mode)
    // if (!isEditMode) {
    const isDuplicate = await validateProcessSelection(selectedProcess, processDate);
    if (isDuplicate) {
      setAlertType('warning');
      setAlertMessage('This process already exists for the selected date! Please select a different process or date.');
      setOpenAlert(true);
      return;
    }
    // }

    try {
      setOpenLoader(true);
      const submitData = prepareSubmitData();

      console.log('Submitting data:', submitData);

      const response = await axios.instance.post('/InsertOtherProcess', submitData, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });

      console.log('Response:', response.data);

      setAlertType('success');
      setAlertMessage(isEditMode ? 'Process updated successfully!' : 'Process created successfully!');
      setOpenAlert(true);

      // Redirect after success
      setTimeout(() => {
        navigate('/dashboard/manage/other_production');
      }, 2000);
    } catch (error) {
      console.error('Error saving process:', error);
      setAlertType('error');
      setAlertMessage('Failed to save process data');
      setOpenAlert(true);
    } finally {
      setOpenLoader(false);
    }
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const total = calculateTotal();

  const StyledTableHeader = styled(TableCell)(({ theme }) => ({
    backgroundColor: '#6482AD',
    color: theme.palette.common.white,
  }));

  // Get selected process name for display
  const getSelectedProcessName = () => {
    const process = processData.find((p) => p.ProcessId.toString() === selectedProcess);
    return process ? process.ProcessName : '';
  };

  if (openLoader && !dataLoaded) {
    return (
      <Dialog open fullWidth maxWidth="xs">
        <DialogContent>
          <LinearProgress />
          <Typography align="center" sx={{ mt: 2 }}>
            Loading...
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 2, maxWidth: 1400, margin: '20px auto' }}>
      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent={'space-between'}
        alignItems={'center'}
        spacing={2}
        style={{ paddingBottom: '20px' }}
      >
        <Box>
          <Link to="/dashboard/manage/other_production">
            <Button variant="outlined" color="info" startIcon={<KeyboardBackspaceIcon />}>
              Back
            </Button>
          </Link>
        </Box>
        <Typography
          variant="h5"
          p={1}
          boxShadow={1}
          borderColor="#11235A"
          textAlign={'center'}
          borderRadius={1}
          pl={2}
          color="white"
          sx={{
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
            background: 'linear-gradient(to right, #3498db, #2c3e50)',
            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
          }}
        >
          <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2}>
            <KeyboardDoubleArrowLeftIcon />
            <Typography variant="h6" color="white" className="font_style1">
              {isEditMode ? 'Edit Other Process' : 'Other Process'}
            </Typography>
          </Stack>
        </Typography>
      </Stack>

      {/* Form Header Section */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {/* Process Select - Dynamic from API */}
        <Grid item xs={12} sm={3}>
          {isEditMode ? (
            // Display only in edit mode
            <FormControl fullWidth size="small">
              <TextField
                label="Process"
                value={getSelectedProcessName()}
                InputProps={{
                  readOnly: true,
                }}
                size="small"
                fullWidth
              />
            </FormControl>
          ) : (
            // Editable in new mode
            <FormControl fullWidth size="small">
              <InputLabel>Select Process</InputLabel>
              <Select value={selectedProcess} label="Select Process" 
              onChange={
                handleProcessChange
                }>
                {processData
                  .filter((process) => !(obProduction && process.ProcessName === 'Production'))
                  .map((process) => (
                    <MenuItem key={selectedProcess.ProcessId} value={process.ProcessId.toString()}>
                      {process.ProcessName}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          )}
        </Grid>

        {/* Date Picker using native input */}
        <Grid item xs={12} sm={2}>
          {/* {isEditMode ? (
                        // Display only in edit mode
                        <TextField
                            label="Process Date"
                            value={processDate}
                            InputProps={{
                                readOnly: true,
                            }}
                            size="small"
                            fullWidth
                        />
                    ) : (
                        // Editable in new mode */}
          <TextField
            label="Process Date"
            type="date"
            size="small"
            value={processDate}
            onChange={(e) => handleDateChange(e.target.value)}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
          {/* )} */}
        </Grid>

        {/* Multi-select Employees - Dynamic from API */}
        <Grid item xs={12} sm={7}>
          <FormControl fullWidth size="small">
            <InputLabel>Select Employees</InputLabel> {/* Added shrink */}
            <Select
              size="small"
              multiple
              value={selectedEmployees}
              onChange={handleEmployeeChange}
              renderValue={(selected) => {
                const selectedEmployeeNames = selected.map((empId) => {
                  const employee = employeeData.find((emp) => emp.UserAccessID.toString() === empId.toString());
                  return employee ? `${employee.UserCode} - ${employee.UserName}` : '';
                });
                return selectedEmployeeNames.join(', ');
              }}
              label="Select Employees"
            >
              {/* Select All Option */}
              <MenuItem value="select-all">
                <Checkbox
                  checked={isAllEmployeesSelected()}
                  indeterminate={isSomeEmployeesSelected()}
                  onChange={handleSelectAllEmployees}
                />
                <ListItemText primary="Select All" />
              </MenuItem>

              {employeeData.map((employee) => (
                <MenuItem key={employee.UserAccessID} value={employee.UserAccessID.toString()}>
                  <Checkbox checked={selectedEmployees.indexOf(employee.UserAccessID.toString()) > -1} />
                  <ListItemText primary={`${employee.UserCode} - ${employee.UserName}`} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {/* Detail Table */}
      <TableContainer
        component={Paper}
        elevation={5}
        sx={{
          maxHeight: 600,
          borderRadius: 1,
          backgroundColor: 'inherit',
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <StyledTableHeader align="center">S.No</StyledTableHeader>
              <StyledTableHeader align="left">Style Details</StyledTableHeader>
              <StyledTableHeader align="center">Qty(pcs)</StyledTableHeader>
              <StyledTableHeader align="center">Actions</StyledTableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {operationDetails.map((obj, index) => {
              const availableStyles = getAvailableStylesForRow(index);

              return (
                <TableRow key={index} hover>
                  {/* S.No */}
                  <TableCell align="center" sx={{ width: '80px' }}>
                    {index + 1}
                  </TableCell>

                  {/* Style Column - Dynamic Dropdown */}
                  <TableCell align="left" sx={{ width: '70%', minWidth: '300px' }}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      options={availableStyles}
                      value={obj.style}
                      onChange={(event, newValue) => {
                        handleStyleChange(index, newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Style"
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: 'white',
                            },
                          }}
                        />
                      )}
                    />
                  </TableCell>

                  {/* Quantity Column */}
                  <TableCell align="center" sx={{ width: '150px', padding: '4px 8px' }}>
                    <TextField
                      type="number"
                      value={obj.quantity}
                      onChange={(e) => handleQuantityChange(index, e.target.value)}
                      variant="outlined"
                      size="small"
                      fullWidth
                      inputProps={{
                        min: 0,
                        style: {
                          textAlign: 'center',
                          padding: '8px 4px',
                        },
                      }}
                      sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: 'white',
                          minWidth: '80px',
                        },
                      }}
                    />
                  </TableCell>

                  {/* Actions */}
                  <TableCell align="center" sx={{ width: '80px', padding: '4px' }}>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => handleDeleteRow(index)}
                      size="small"
                      disabled={operationDetails.length === 1}
                    >
                      <DeleteForeverIcon color={operationDetails.length === 1 ? 'disabled' : 'error'} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}

            {/* Total Row */}
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 'bold',
                  width: '80px',
                }}
              >
                -
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  fontWeight: 'bold',
                }}
                colSpan={1}
              >
                Total
              </TableCell>
              <TableCell align="center" sx={{ width: '150px', padding: '4px 8px' }}>
                <TextField
                  value={total}
                  variant="outlined"
                  size="small"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    sx: {
                      fontWeight: 'bold',
                      backgroundColor: '#e3f2fd',
                      '& input': {
                        textAlign: 'center',
                        fontWeight: 'bold',
                        padding: '8px 4px',
                      },
                    },
                  }}
                />
              </TableCell>
              <TableCell align="center" sx={{ width: '40px', padding: '5px' }}>
                <IconButton aria-label="Add" onClick={handleAddRow} size="medium" color="primary">
                  +
                </IconButton>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Submit Button */}
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={openLoader}>
          {isEditMode ? 'Update Process' : 'Save Process'}
        </Button>
      </Box>

      {/* Loader Dialog */}
      <Dialog open={openLoader} fullWidth maxWidth="xs">
        <DialogContent>
          <LinearProgress />
          <Typography align="center" sx={{ mt: 2 }}>
            Processing...
          </Typography>
        </DialogContent>
      </Dialog>
    </Paper>
  );
};

export default OtherProcess;
